export default {
  message: {
    "strid1": "首页",
    "strid2": "教学",
    "strid3": "活动",
    "strid4": "加入我们",
    "strid5": "Discord",
    "strid6": "创作者学院",
    "strid7": "优秀作品",
    "strid8": "返回",
    "strid9": "立即参与",
    "strid10": "其他活动",
    "strid11": "个人信息",
    "strid12": "游戏服务器ID",
    "strid13": "请输入服务器ID",
    "strid14": "游戏ID",
    "strid15": "请输入游戏ID",
    "strid16": "个人联系方式",
    "strid17": "选择平台",
    "strid18": "请输入联系方式",
    "strid19": "作品信息",
    "strid20": "作品发布平台",
    "strid21": "请正确填写链接",
    "strid22": "点击新增一条链接",
    "strid23": "作品所用语言",
    "strid24": "选择作品语言",
    "strid25": "英语",
    "strid26": "阿拉伯语",
    "strid27": "西班牙语",
    "strid28": "葡萄牙语",
    "strid29": "柬埔寨语",
    "strid30": "缅甸语",
    "strid31": "马来西亚语",
    "strid32": "其他",
    "strid33": "我确认拥有作品所有权并认可此协议",
    "strid34": "提交",
    "strid35": "提交成功！",
    "strid36": "权益",
    "strid37": "现在加入即可获得",
    "strid38": "官方社媒的大力支持",
    "strid39": "创作者互动社群",
    "strid40": "每周钻石",
    "strid41": "更多权益有待解锁",
    "strid42": "游戏周边",
    "strid43": "线下活动",
    "strid44": "海量皮肤",
    "strid45": "品牌合作",
    "strid46": "广告宣传",
    "strid47": "加入我们",
    "strid48": "Requirements",
    "strid49": "关注我们",
    "strid50": "点击查看MLBB官方账号",
    "strid51": "《协议内容》",
    "strid52": "请填写完整信息",
    "strid53": "提交失败",
    "strid54": "Please Enter Your Channel Link",  // 请输入正确的频道链接
    "strid55": "选择你的国籍/地区",
    "strid56": "你的国籍/地区",


  }
}
